import { render, staticRenderFns } from "./TipoPercepcion.vue?vue&type=template&id=3051eb04&scoped=true"
import script from "./TipoPercepcion.vue?vue&type=script&lang=js"
export * from "./TipoPercepcion.vue?vue&type=script&lang=js"
import style0 from "./TipoPercepcion.vue?vue&type=style&index=0&id=3051eb04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051eb04",
  null
  
)

export default component.exports